import { useState } from 'react';
import { GridFolderData } from './gridfolder';

const FolderData = ({ isPoppedUp, HandleSave }) => {
  const [allfoldersData, setAllfoldersData] = useState([]);

  return (
    <>
      <div className=" ">
        <GridFolderData
          isPoppedUp={isPoppedUp}
          HandleSave={HandleSave}
          data={allfoldersData}
          setdata={setAllfoldersData}
        />
      </div>
    </>
  );
};

export default FolderData;
